<template>
  <div class="index">
    <div class="header">
      <div class="header-logo"><img src="../assets/image/logo.png"/></div>
      <div class="header-name">{{ $t('index.systemName') }}</div>
      <div class="header-lang">
        <LangSwitcher />
      </div>
    </div>
    <div class="center">
      <div class="center-card">
        <el-carousel :interval="10000" type="card" height="560px" indicator-position="none" :autoplay="true">
          <el-carousel-item v-for="item in competitionList" :key="item.id">
           <div class="competition-info">
             <img class="com-images" :src="define.previewNginxUrl + item.coverImage"/>
             <div class="com-name" :title="$i18n.locale === 'zh-CN' ? item.nameCh : (item.nameEn || item.nameCh)">{{ $i18n.locale === 'zh-CN' ? item.nameCh : (item.nameEn || item.nameCh) }}</div>
             <div class="com-register-time">
               <div class="register-time-left">
                 <div class="info-head">
                   <i class="el-icon-date"></i>
                   <span>{{ $t('index.registerTime') }}</span>
                 </div>
                 <div class="info-body">{{item.registerStartTime}} - {{item.registerEndTime}}</div>
               </div>
               <div class="register-status-1" v-if="item.registerStatus === 1">{{ $t('index.statusPending') }}</div>
               <div class="register-status-2" v-if="item.registerStatus === 2">{{ $t('index.statusOpen') }}</div>
               <div class="register-status-3" v-if="item.registerStatus === 3">{{ $t('index.statusClosed') }}</div>
             </div>
             <div class="com-apply">
               <div class="com-apply-left">
                 <div class="com-time">
                   <div class="info-head">
                     <i class="el-icon-time"></i>
                     <span>{{ $t('index.matchTime') }}</span>
                   </div>
                   <div class="info-body">{{item.startTime}} - {{item.endTime}}</div>
                 </div>
                 <div class="com-address">
                   <div class="info-head">
                     <i class="el-icon-location-outline"></i>
                     <span>{{ $t('index.matchVenue') }}</span>
                   </div>
                   <div class="info-body" :title="$i18n.locale === 'zh-CN' ? item.addressCh : (item.addressEn || item.addressCh)">{{ $i18n.locale === 'zh-CN' ? item.addressCh : (item.addressEn || item.addressCh) }}</div>
                 </div>
               </div>
               <div class="com-apply-click" @click="toHome(item)">
                {{ $t('common.enter') }}
               </div>
             </div>
           </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { getCompetitionList } from "@/api/competition";
import Footer from "@/components/Footer.vue";
import LangSwitcher from "@/components/LangSwitcher.vue";
export default {
  name: 'index',
  components: { Footer, LangSwitcher },
  data() {
    return {
      // 赛事列表
      competitionList: []
    };
  },
  created() {
    this.findCompetitionList();
  },
  mounted() {

  },
  methods: {
    // 进入首页
    toHome(obj){
      if (obj.registerStatus === 1) {
        return this.$message.warning(this.$t('index.warnNotStarted'));
      }
      if (obj.registerStatus === 3) {
        return this.$message.warning(this.$t('index.warnEnded'));
      }
      let isRegisterAdmin = Number(localStorage.getItem("isRegisterAdmin"));
      if (isRegisterAdmin === 0) {
        this.$router.push({ path: "/home?id=" + obj.id });
      }
      if (isRegisterAdmin === 1) {
        this.$router.push({ path: "/manager?id=" + obj.id });
      }
    },
    // 赛事列表
    findCompetitionList(){
      let params = {
        id: 1
      }
      getCompetitionList(params).then((res) => {
        this.competitionList = res.data.list;
      });
    }
  },
};
</script>
<style lang="scss" scoped>

.index {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url('../assets/image/home_bj.jpg') no-repeat;
  background-size: cover;

  .header {
    width: 100%;
    line-height: 120px;
    background-color: #001c58;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-logo {
      width: 100px;
      height: 100px;
      margin-left: 20px;
    }

    .header-name{
      font-size: 40px;
      color: #FFFFFF;
      font-weight: 600;
      margin: 0 auto;
    }

    .header-lang {
      margin-right: 20px;
      line-height: normal;
      display: flex;
      align-items: center;
      height: 100%;
    }
  }

  .center {
    width: 100%;
    height: 600px;

    .center-card{
      width: 100%;
      max-width: 1000px;
      margin: 50px auto;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      border-radius: 16px;

      .competition-info {
        width: 100%;
        border-radius: 12px;
        overflow: hidden;

        .com-images{
          width: 100%;
          height: 290px;
        }

        .com-name {
          height: 60px;
          line-height: 60px;
          background: linear-gradient(135deg, #2c3e50, #1a1a2e);
          font-size: 20px;
          color: #ffffff;
          font-weight: 600;
          padding: 0 16px;
          margin: 10px;
          border-left: 4px solid #409EFF;
          border-radius: 0 4px 4px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .com-register-time {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          margin-bottom: 6px;

          .register-time-left {
            flex: 1;
            min-width: 0;
            height: 40px;
            padding: 8px 14px;
            background: #f8f9fc;
            border-radius: 8px;
            border-left: 3px solid #409EFF;
            margin-right: 10px;

            .info-head {
              display: flex;
              align-items: center;
              gap: 6px;
              font-size: 13px;
              color: #909399;
              margin-bottom: 4px;

              i {
                font-size: 14px;
                color: #409EFF;
              }
            }

            .info-body {
              font-size: 15px;
              color: #333;
              font-weight: 500;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .register-status-1 {
            font-size: 20px;
            width: 80px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #fff;
            font-weight: 600;
            background: #909399;
            border-radius: 25px;
            flex-shrink: 0;
          }

          .register-status-2 {
            font-size: 20px;
            width: 80px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #fff;
            font-weight: 600;
            background: #5bc001;
            border-radius: 25px;
            flex-shrink: 0;
          }

          .register-status-3 {
            font-size: 20px;
            width: 80px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #fff;
            font-weight: 600;
            background: #909399;
            border-radius: 25px;
            flex-shrink: 0;
          }
        }

        .com-apply {
          display: flex;
          justify-content: space-between;
          padding: 0 10px;

          .com-apply-left {
            flex: 1;
            min-width: 0;
            padding-right: 10px;

            .com-time {
              height: 40px;
              padding: 8px 14px;
              background: #f8f9fc;
              border-radius: 8px;
              border-left: 3px solid #409EFF;
              margin-bottom: 6px;

              .info-head {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 13px;
                color: #909399;
                margin-bottom: 4px;

                i {
                  font-size: 14px;
                  color: #409EFF;
                }
              }

              .info-body {
                font-size: 15px;
                color: #333;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .com-address {
              height: 40px;
              padding: 8px 14px;
              background: #f8f9fc;
              border-radius: 8px;
              border-left: 3px solid #409EFF;

              .info-head {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 13px;
                color: #909399;
                margin-bottom: 4px;

                i {
                  font-size: 14px;
                  color: #409EFF;
                }
              }

              .info-body {
                font-size: 15px;
                color: #333;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }

          .com-apply-click {
            font-size: 20px;
            width: 80px;
            height: 116px;
            line-height: 116px;
            text-align: center;
            color: #fff;
            font-weight: 600;
            background: #001c58;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
            flex-shrink: 0;

            &:hover {
              transform: scale(1.05);
              box-shadow: 0 4px 12px rgba(0, 28, 88, 0.4);
            }
          }
        }
      }
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: #d3dce6;
    }
  }
}
</style>
